import { StorageRoom } from "src/app/inventory/storageRoom";

export class ParentItem{
  Food: { Name: string, FoodId: string, Price: number, Quantity: number, ToCook: boolean, FranchiseId?: string | null }[];
  Inventory: { Name: string, InventoryId: string, Price: number, Quantity: number, UOM: string, PreferredStockLevel: number, LowInventoryCount: number, StorageRoom: StorageRoom, ToCook: boolean, FranchiseId?: string | null }[];
}


